import React from 'react';
import { TextToImagePhone, EnhancePhone, HairPhone } from './MiniPhone';
import { Sparkles, Layers, Scissors, Zap } from 'lucide-react';

const cards = [
  {
    title: 'Text-to-Image Generation',
    desc: 'Describe any concept in plain text and watch AI paint it instantly — realistic portraits, vivid landscapes, or specialized artwork.',
    Phone: TextToImagePhone,
    icon: Sparkles,
    tag: 'Visual Art',
  },
  {
    title: 'Instant One-Tap Enhance',
    desc: 'Restore old, faded, or heavily blurred photos. Instantly scale resolution up to 4× with pristine detail preservation.',
    Phone: EnhancePhone,
    icon: Zap,
    tag: 'Upscaling',
  },
  {
    title: 'Virtual Hairstyle Try-On',
    desc: 'Preview dozens of premium hairstyles, modern cuts, and studio colors directly on your selfie before making salon choices.',
    Phone: HairPhone,
    icon: Scissors,
    tag: 'AI Styling',
  },
];

export default function FeaturesDark() {
  return (
    <section id="features" className="py-24 px-6 max-w-7xl mx-auto relative">
      <div className="text-center mb-16">
        <div className="inline-flex items-center gap-2 bg-[#161B26] border border-gray-800 px-4 py-1.5 rounded-full text-sm font-semibold text-[#E63946] mb-4">
          <Layers className="w-4 h-4" /> Unparalleled Power
        </div>
        <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight text-white">
          Engineered for <span className="text-[#E63946]">Editing Mastery</span>
        </h2>
        <p className="text-gray-400 mt-4 max-w-2xl mx-auto text-base md:text-lg">
          Transform your digital assets with advanced instructions. No layer management or technical masking needed.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {cards.map((card, i) => {
          const IconComp = card.icon;
          return (
            <div
              key={i}
              className="bg-[#121622] border border-gray-800/80 rounded-3xl p-8 flex flex-col justify-between hover:border-[#E63946]/40 transition-all duration-300 group overflow-hidden relative"
            >
              {/* Top ambient glow */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32 bg-[#E63946]/5 rounded-full blur-2xl pointer-events-none" />

              <div>
                <div className="flex items-center justify-between mb-6">
                  <div className="w-12 h-12 rounded-2xl bg-[#1B2030] border border-gray-800 flex items-center justify-center group-hover:scale-110 group-hover:border-[#E63946]/40 transition-all duration-300">
                    <IconComp className="w-6 h-6 text-[#E63946]" />
                  </div>
                  <span className="text-xs font-bold uppercase tracking-widest text-[#F6D365]">
                    {card.tag}
                  </span>
                </div>

                <h3 className="text-xl md:text-2xl font-bold text-white mb-3 group-hover:text-[#E63946] transition-colors">
                  {card.title}
                </h3>
                <p className="text-gray-400 text-sm md:text-base leading-relaxed">
                  {card.desc}
                </p>
              </div>

              <div className="pt-6 mt-6 border-t border-gray-800/40 relative">
                <card.Phone />
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
